export default __webpack_public_path__ + "static/media/lounge-banner2.89834d78.jpg";